import axios from "axios";
import { getAuthHeaders } from "../../config/auth/auth";

// const { REACT_APP_URL_API } = process.env;
const url: any = process.env.REACT_APP_URL_API;

export const Httpcommon = axios.create({
  baseURL: url,
  headers: {
    "Content-type": "application/json"
  },
});

Httpcommon.interceptors.request.use(
  async (config: any) => {
    const headers = await getAuthHeaders();
    // console.log(headers)

    return { ...config, headers };
  },
  (error) => Promise.reject(error)
);
